import { getAuthHeaders } from "../AuthHeader/getAuthHeader";
import api from "../Interceptors";
import { ApiError } from "../ApiError";

export interface SubmitHelpQueryPayload {
    projectId: string;
    queries: string;
}

export const submitHelpQuery = async (payload: SubmitHelpQueryPayload) => {
    try {
        const header = await getAuthHeaders();
        const config = {
            headers: {
                "Content-Type": "application/json",
                ...header,
            },
        };
        const res = await api.post("/queries", payload, config);
        return res.data;
    } catch (error) {
        throw new ApiError(error);
    }
};
